import { Component, OnInit, ViewChild, ElementRef, isDevMode } from '@angular/core';
import { MultiInputStepComponent } from '../../step/multi-input-step/multi-input-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-zip-code',
  templateUrl: './zip-code.component.html',
  styleUrls: ['./zip-code.component.scss', '../../step/step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})

export class ZipCodeComponent extends MultiInputStepComponent implements OnInit {
  @ViewChild('zipCode') zipCodeField: ElementRef;
  @ViewChild('streetAddress') streetAddressField: ElementRef;

  protected propertyTypeName: String;
  public askAddress: Boolean;
  public experiment: Boolean;
  public subtext: String;
  public zipCodeHeader: String;
  public streetAddressHeader: String;
  public displayNewZipQuestion: boolean = false;
  public notDebtSettlement: boolean;
  NotSureZipCodeAddress: boolean = false;
  ShowErrorMessage: boolean = true;
  purchaseStateStepDropdown = false;
  stateHeader = `What state is the property located in?`;
  initialState: string;
  selectedState: string | null;
  showSelectsError: boolean;
  zipValidators = [Validators.required, Validators.pattern('^[0-9]{5}$')];
  addressValidators = [Validators.required, Validators.pattern('^[\\s]*[A-Za-z0-9,#.\'-]+[A-Za-z0-9\\s,#.\'-]*$')];
  addressControl = new UntypedFormControl('', this.addressValidators);
  disableStreetAddress = false;
  zipInputSubscriptions = new Subscription();

  ngOnInit() {
    // Zip code validation
    this.controls.push(new UntypedFormControl('', this.zipValidators));
    this.controls.push(this.addressControl);

    this.form.addControl('zipCode', this.controls[0]);
    this.form.addControl('streetAddress', this.controls[1]);

    this.zipCodeHeader = "What's your zip code?";
    this.streetAddressHeader = "Street Address";

  }

  initStep() {
    // check if notDebtSettlement
    this.notDebtSettlement = this.form.controls.formType.value != 'debtsettlement' && this.form.controls.formType.value != 'debtrelief';
    this.initializeStateDropdown();
    // for experiment:
    this.propertyTypeName = {
      "Single": "house",
      "Multi": "property",
      "Condo": "condo",
      "Town House": "town house",
      "Cooperative": "property",
      "Mobile": "house",
      "Manufactured": "house"
    }[this.form.controls.propertyType.value] || "house";

    this.subtext = 'Used to verify home value';
    this.askAddress = this.form.controls.buyingProcess.value == 'found_home' || this.form.controls.buyingProcess.value == 'signed_agreement';

    if (this.form.controls.type.value === 'purchase') {
      this.zipCodeHeader = "What's the new zip code?";
      this.streetAddressHeader = "Street Address";
    }
    if (!this.askAddress) {
      if (this.controls.length == 2) {
        this.form.removeControl('streetAddress');
        this.controls.pop();
      }
    } else {
      if (this.controls.length == 1) {
        //We previously removed addressControl and then different steps were picked, add it back
        this.controls.push(this.addressControl);
        this.form.addControl('streetAddress', this.controls[1]);
      }
    }

    if (this.zipCodeField) {
      setTimeout(() => this.zipCodeField.nativeElement.focus(), 0);
    }

    if (!environment.production) {
      this.form.controls.zipCode.setValue(this.randomService.consumer.zipCode.toString());
    }
  }

  initializeStateDropdown(resetSelectedState: boolean = false) {
    this.showSelectsError = false;
    this.purchaseStateStepDropdown = false;
    if(resetSelectedState){
      this.selectedState , this.initialState = '';
    }else{
      this.initialState = this.form.controls.propertyState.value || '';
      this.selectedState = this.initialState;
      this.disableStreetAddress = this.controls[0].value.length !== 5;
      this.zipInputSubscriptions.add(this.controls[0].valueChanges
        .pipe(distinctUntilChanged()) // makes sure the value has actually changed.
        .subscribe(data => this.disableStreetAddress = data.length !== 5));
    }
    // in case if user goes form back and force repeat
    if (!this.controls[0].hasValidator(Validators.required)) {
      this.controls[0].setValidators(this.zipValidators);
      this.controls[0].updateValueAndValidity();
    }
    if (this.controls[1]?.hasValidator(Validators.required)) {
      this.controls[1]?.clearValidators();
      this.controls[1]?.updateValueAndValidity();
    }
  }

  submit() {

    if (this.controls[0].value.length < 5 && this.initialState !== '') {
      this.initializeStateDropdown(true);
    }
    if (this.controls[0].status == 'INVALID') {
      this.controls[0].setErrors(null);
      this.selectedState = this.initialState;
      this.purchaseStateStepDropdown = true;
      return true;
    }
    // if (this.NotSureZipCodeAddress){
    //   this.ShowErrorMessage = false;
    //   this.controls[0].setErrors(null);
    //   this.controls[1].setErrors(null);
    //   this.form.controls.propertyState.setValue('');
    //   this.form.controls.propertyCity.setValue('');
    // } else
    if (this.selectedState === '' && this.purchaseStateStepDropdown) {
      this.showSelectsError = true;
      return true;
    }
    if (this.selectedState && this.purchaseStateStepDropdown) {
      this.form.controls.propertyState.setValue(this.selectedState);
      this.form.controls.propertyCity.setValue(this.communication.state.state_capital || '');
      this.controls[0].setValue(this.communication.state.state_default_zip || '');
      this.controls[0].clearValidators();
      this.controls[0].updateValueAndValidity();
    } else {
      this.ShowErrorMessage = true;
      // Get zip details
      this.fruHttpService.getZipDetails(this.controls[0].value, this.form.controls.type.value, this.form.controls.creditRating.value).subscribe((response) => {
        // if (response.enabled === false) {
        //   // Redirect if the state comes back disabled
        //   if (isDevMode()) {
        //     console.log('Zip code disabled state redirect');
        //   }
        //   this.fruHttpService.redirectRateTables(this.form);
        // } else if (response.lender && parseInt(response.lender) === 0) {
        //   // Redirect if lenders comes back as 0
        //   // if (isDevMode()) {
        //   //   console.log('Zip code no lender redirect');
        //   // }
        //   // this.fruHttpService.redirectRateTables(this.form);
        // } else {
          // Populate state and city
        this.form.controls.propertyState.setValue(response.state || '');
        this.form.controls.propertyCity.setValue(response.city || '');
        // }
      });
    }
    super.submit();
  }

  /** @ToDo remove it if not used */
  reloadComponent () {
    this.ShowErrorMessage = false;
    this.controls[0].setErrors(null);
    this.controls[1].setErrors(null);
    if (this.NotSureZipCodeAddress){
      this.zipCodeHeader = "What's your current zip code?";
      this.streetAddressHeader = "Current Street Address";
      this.NotSureZipCodeAddress = true;
    }
    else{
      this.form.controls.propertyState.setValue('');
      this.form.controls.propertyCity.setValue('');
      super.submit();
    }
  }

  selectState(event:string){
    this.showSelectsError  = event === '' ;
    this.selectedState = event;
  }
}
